import { Typography, AnchorMenu, Tag } from "components";
import { ROUTES } from "routes/routePaths";
import { genderOptions, userStatuses } from "utils/constants";
import { AiOutlineEye } from "react-icons/ai";
import { capitalizeFirstLetter, formatDateTime } from "utils/helper";
import { Link } from "react-router-dom";

const agentAnchorRender = (userInfo) => {
  return (
    <ul className="py-1" style={{ paddingLeft: ".6rem" }}>
      <li>
        <Link
          to={ROUTES.viewUser}
          state={{ userInfo }}
          style={{ textDecoration: "none" }}
        >
          <Typography state="primary" variant="caption1">
            <AiOutlineEye fontSize="14px" /> View Agent Profile
          </Typography>
        </Link>
      </li>
    </ul>
  );
};

const getStatusTag = (value) => {
  let val = userStatuses.find((status) => status.mapper === value);
  return val ? (
    <Tag text={val.text} backgroundColor={val.bgColor} textColor={val.color} />
  ) : (
    ""
  );
};

export const agentColumns = [
  {
    Header: "S/N",
    Cell: (row) => {
      let sn = Number(row.row.id) + 1;
      return sn.toString().length === 1 ? "0" + sn : sn;
    },
  },
  // {
  //   Header: "Name",
  //   Cell: ({ row }) =>
  //     capitalizeFirstLetter(row.original.firstName) +
  //     " " +
  //     capitalizeFirstLetter(row.original.lastName),
  // },
  {
    Header: "Agent Name",
    Cell: ({ row }) => {
      const { firstName, lastName, agentDetails } = row.original || {};

      if (agentDetails?.corporate) return agentDetails?.corporateName;

      return (
        capitalizeFirstLetter(firstName) + " " + capitalizeFirstLetter(lastName)
      );
    },
  },
  {
    Header: "Corporate",
    Cell: ({ row }) => (row.original?.agentDetails?.corporate ? "Yes" : "No"),
  },
  {
    Header: "Gender",
    accessor: "gender",
    Cell: ({ value }) =>
      genderOptions.find((gender) => gender.value === value)?.label || "",
  },
  {
    Header: "Agent Code",
    accessor: "agentDetails",
    Cell: ({ value }) => value.agentCode || "Nil",
    customWidth: "7rem",
  },
  {
    Header: "Username",
    accessor: "username",
  },
  {
    Header: "Date Registered",
    accessor: "createdDate",
    Cell: ({ row }) => formatDateTime(row.original.agentDetails.createdDate),
    customWidth: "8rem",
  },
  {
    Header: "Status",
    accessor: "status",
    Cell: ({ row }) => getStatusTag(row.original.agentDetails.status),
    customWidth: "10rem",
  },
  {
    Header: "Action",
    Cell: (props) => (
      <AnchorMenu anchorRender={() => agentAnchorRender(props.row.original)} />
    ),
  },
];
